import { Component, inject, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import AuthService from './auth/auth.service';
import { FullScreenSpinner } from './shared/components/full-screen-spinner';
import { MainLayout } from './core/layout/main-layout';

@Component({
  selector: 'tlm-root',
  imports: [MainLayout, FullScreenSpinner],
  templateUrl: './app.html',
})
export class App implements OnInit {
  protected readonly authService = inject(AuthService);
  private readonly oidcSecurityService = inject(OidcSecurityService);

  ngOnInit(): void {
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        this.oidcSecurityService.authorize();
      } else {
        this.authService.loadUser().subscribe();
      }
    });
  }
}
